import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  emptyResult: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center"
  },
  emptyResultText: {
    color: theme.palette.text.secondary,
    fontSize: 18,
    lineHeight: 1,
    marginBottom: 16
  },
  clearSearch: {
    borderColor: theme.palette.text.secondary,
    color: theme.palette.text.secondary
  },
  textSearch: {
    fontSize: 14,
    margin: 0
  }
}));
